
<span matSnackBarLabel>
  {{ snackBarRef.containerInstance.snackBarConfig.data.message }}
</span>
<span matSnackBarActions>
  <htx-button variant="ghost" matSnackBarAction (click)="snackBarRef.dismissWithAction()">
    {{ snackBarRef.containerInstance.snackBarConfig.data.action }}
  </htx-button>
</span>
